import { useProjectAccessContext } from '../../context/projectAccess';
import { canViewDownloadLogs } from '../../helpers/projectPermissions';
import { DOWNLOAD_LOGS_ENABLED } from '../../config/featureFlags';
import { DownloadLogsView } from '../DownloadLogs/DownloadLogsView';

interface TabDownloadLogsProps {
  projectId: string;
  isOwner: boolean;
}

/**
 * Project-tab wrapper around the shared DownloadLogsView. Re-checks the
 * owner/system-admin gate here (in addition to the tab-bar visibility gate in
 * Project.tsx) as cheap insurance against a hidden tab being reached via a
 * stale localStorage/URL tab param.
 */
export const TabDownloadLogs = ({ projectId, isOwner }: TabDownloadLogsProps) => {
  const { access } = useProjectAccessContext();

  const allowed = DOWNLOAD_LOGS_ENABLED && canViewDownloadLogs(access, isOwner);

  if (!allowed) {
    return <div className="py-12 text-center text-[#888]">You do not have permission to view the download log.</div>;
  }

  return <DownloadLogsView scope="project" projectId={projectId} />;
};
